import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useWrapperStore } from '../../store/storeWrapper'
import { SidebarType } from '../../types/sidebars'

export const RequestSettingButton = ({ isDisabled }) => {
    const { openSidebarType, setOpenSidebarType } = useWrapperStore((state) => state)

    return (
        <Tooltip title="Отображение и скрытие панели настроек запроса">
            <IconButton
                sx={{
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    border: '1px solid #E5E5E7',
                    '&:hover': {
                        border: '1px solid #E5E5E7',
                        background: '#F6F6F6',
                    },
                }}
                variant="text"
                color="primary"
                disabled={isDisabled}
                onClick={() => {
                    setOpenSidebarType(
                        openSidebarType === SidebarType.REQUESTS_SETTINGS
                            ? null
                            : SidebarType.REQUESTS_SETTINGS,
                    )
                }}>
                <SettingsOutlinedIcon />
            </IconButton>
        </Tooltip>
    )
}
